import { Button, Form, Input, message } from "antd";
import { useCallback, useEffect, useRef, useState } from "react";
import apiCalls from "src/api/apiCalls";
import Loader from "src/components/loader.component";
import { isErrorMessage } from "src/components/shared/error.message";
import PhoneCodeDropdown from "src/components/shared/phCodeDropdown";
import { alphanumericPattern } from "src/utils/custom.validator";
const PersonalInfo = ({ handleError }) => {
    const [loader, setLoader] = useState(false)
    const [buttonLoader, setButtonLoader] = useState(false)
    const [info, setInfo] = useState([])
    const [form] = Form.useForm();
    const shouldLog=useRef(true)
    useEffect(() => {
        if (shouldLog.current) {
            shouldLog.current = false;
            getPersonalInfo()
          }
    }, [])
    const getPersonalInfo = useCallback(async () => {
        setLoader(true);
        try {
            const response = await apiCalls.personalInfo();
            if (response.ok) {
                setInfo(response?.data);
                let { phoneNumber, ...restData } = response?.data;
                let phoneCode = null;
                let number = response?.data?.phoneNumber;
                if (phoneNumber && phoneNumber !== "") {
                    const parts = phoneNumber.split(" ");
                    if (parts.length > 1) {
                        phoneCode = parts[0];
                        number = parts.slice(1).join(" ");
                    }
                }
                form.setFieldsValue({
                    ...restData,
                    phoneCode: phoneCode,
                    phoneNumber: number,
                });
                handleError(null);
            } else {
                handleError(isErrorMessage(response?.data));
            }
        } catch (error) {
            handleError(error);
        } finally {
            setLoader(false);
        }
    }, [form, handleError]);
    const handlePhoneCode = useCallback((value) => {
        form.setFieldsValue({ phoneCode: value });
    }, [form]);
    const updatePersonalInfo = useCallback(async (values) => {
        setButtonLoader(true);
        try {
            const phoneCode = values?.phoneCode || "";
            const phoneNum = values?.phoneNumber || "";

            let phoneNumber = "";

            if (phoneNum?.startsWith(phoneCode)) {
                phoneNumber = phoneNum;
            } else if (phoneCode && phoneNum) {
                phoneNumber = `${phoneCode} ${phoneNum}`;
            }
            let saveObject = {
                userName: values?.userName,
                name: values?.name,
                surname: values?.surname,
                email: values?.email,
                phoneNumber: phoneNumber,
                concurrencyStamp: info?.concurrencyStamp,
            };
            const response = await apiCalls.editPersonalInfo(saveObject);
            if (response?.ok) {
                await getPersonalInfo();
                message.success({
                    content: "Profile Updated Successfully",
                    className: "custom-msg",
                    duration: 3,
                });
                handleError(null);
            } else {
                handleError(isErrorMessage(response?.data));
            }
        } catch (error) {
            handleError(error);
        } finally {
            setButtonLoader(false);
        }
    }, [getPersonalInfo, info, handleError]);

    return (
        <>
            {loader ? <><div className="h-[50vh] w-full flex justify-center items-center"><Loader className="" /></div></> : <div className=" flex-1 profile-info">
                <Form form={form} onFinish={updatePersonalInfo}>
                    <div className="grid md:grid-cols-2 gap-4 custom-user-input">
                        <div>
                            <Form.Item className="custom-input" name="userName" label="User Name" rules={[
                                { required: true, message: "Is required" },
                                {
                                    pattern: alphanumericPattern,
                                    message: "Accepts alphanumeric and special chars."
                                }
                            ]}>
                                <Input placeholder="Enter User Name" className="w-full appearance-none " disabled={true} />
                            </Form.Item>
                        </div>
                        <div>
                            <Form.Item className="custom-input" name="name" label="First Name" rules={[
                                { required: true, message: "Is required" },
                                { pattern: alphanumericPattern, message: "Invalid firstname." },
                                //{ min: 2, message: "Invalid firstname." },
                                { max: 50, message: "Invalid firstname." },
                            ]}>
                                <Input placeholder="Enter First Name" className="w-full appearance-none " />
                            </Form.Item>
                        </div>
                        <div>
                            <Form.Item className="custom-input" name="surname" label="Last Name" rules={[
                                { required: true, message: "Is required" },
                                { pattern: alphanumericPattern, message: "Invalid lastname." },
                                //{ min: 2, message: "Invalid lastname." },
                                { max: 50, message: "Invalid lastname." },
                            ]}>
                                <Input placeholder="Enter Last Name" className="w-full appearance-none " />
                            </Form.Item>
                        </div>
                        <div>
                            <Form.Item className="custom-input" name="email" label="Email"
                                rules={[
                                    { required: true, message: "Is required" },
                                    {
                                        type: "email",
                                        message: "Invalid Email Address."
                                    },
                                ]}>
                                <Input placeholder="Enter Email" disabled={true} />
                            </Form.Item>
                        </div>
                        <div>
                            <Form.Item className="custom-input" name="phoneNumber" label="Phone No"
                                rules={[
                                    { pattern: /^\d{6,12}$/, message: "Invalid phone number." }
                                ]}>
                                <Input
                                    addonBefore={
                                        <Form.Item name="phoneCode">
                                            <PhoneCodeDropdown
                                                value={form.getFieldValue("phoneCode")} onChange={handlePhoneCode}
                                            />
                                        </Form.Item>
                                    } placeholder="Phone No" className="input-field"
                                    maxLength={12}
                                />
                            </Form.Item>
                        </div>

                    </div>
                    <div>
                        <div className='text-end pb-3.5 md:mt-0 !mt-3'>
                            <Button className='primary-btn' type="primary" htmlType="submit" loading={buttonLoader}>Save</Button>
                        </div>
                    </div>
                </Form>
            </div>}
        </>
    )
}
export default PersonalInfo;